/* eslint-disable max-len */
/* eslint-disable no-console */
import { API } from 'aws-amplify';
import {
	GET_USERS_BY_ROLES,
	GetUsersByRolesPayload,
	GetUsersByRolesResponse,
	User
} from './types';

// API endpoint name as configured in index.tsx
const API_NAME = 'revisedResources';

/**
 * Get users by their roles (admin, employee, etc.)
 * @param payload - Object containing the roles to filter by and the company ID
 * @returns The list of users matching the specified roles
 */
export const getUsersByRoles = async (
	payload: GetUsersByRolesPayload
): Promise<User[]> =>
{
	if (!payload.companyId)
	{
		console.error('Company ID is required for getUsersByRoles');

		return [];
	}

	if (!payload.roles || !Array.isArray(payload.roles) || payload.roles.length === 0)
	{
		console.error('At least one role must be specified for getUsersByRoles');

		return [];
	}

	try
	{
		// Use the API gateway configured with Amplify
		const response = await API.post(
			API_NAME,
			'/users/by-roles',
			{
				body : payload
			}
		);

		// Handle different response formats
		// Direct format: { success: true, data: User[], count: number }
		if (response?.success && Array.isArray(response?.data))
		{
			return response.data;
		}
		// Nested format: { data: { success: true, data: User[], count: number } }
		else if (response?.data?.success && Array.isArray(response?.data?.data))
		{
			return response.data.data;
		}
		// Another possible format: just array of users
		else if (Array.isArray(response))
		{
			return response;
		}

		// If the response format is unexpected, log and return empty array
		console.warn('Unexpected response format from getUsersByRoles:', response);

		return [];
	}
	catch (error)
	{
		console.error('Error fetching users by roles:', error);
		throw error;
	}
};